import SupportedPhoneNumberTypes from './SupportedPhoneNumberTypes';

// Supported countries as defined in https://knowledge.hubspot.com/articles/kcs_article/calling/what-countries-are-supported-by-calling
export default {
  [SupportedPhoneNumberTypes.SALES_HUB]: [
    'ar',
    'at',
    'au',
    'cx',
    'cc',
    'be',
    'br',
    'bg',
    'ca',
    'cl',
    'cn',
    'co',
    'cr',
    'cz',
    'cy',
    'dk',
    'ee',
    'fi',
    'fr',
    'de',
    'gr',
    'in',
    'ie',
    'il',
    'it',
    'jp',
    'lv',
    'lt',
    'lu',
    'mt',
    'mx',
    'nl',
    'nz',
    'no',
    'pa',
    'pe',
    'pl',
    'pt',
    'ro',
    'sg',
    'sk',
    'za',
    'kr',
    'es',
    'se',
    'ch',
    'gb',
    'us',
  ],
  [SupportedPhoneNumberTypes.CRM]: [
    'au',
    'br',
    'fr',
    'de',
    'ie',
    'jp',
    'es',
    'gb',
    'us',
  ],
};
